import { useState, useRef, useEffect } from 'react';

import { useMediaQuery } from 'react-responsive';

import { ChevronDownIcon, HamburgerIconComponent } from 'assets/icons';
// import { InfoBoldIcon } from 'assets/icons';
import { ProfilePopover, LangMenu } from 'components';
import NotificationsPopover from 'components/NotificationsPopover';
// import menuIcon from 'assets/icons/menu-outline.svg';
import styles from './styles.module.scss';
import useTranslation from 'hooks/useTranslation';
import clsx from 'clsx';
// import discount from 'assets/icons/discount.svg';

function Header({ showMenu, setShowMenu }) {
  const isMdDown = useMediaQuery({
    query: '(max-width: 992px)',
  });
  const boxRef = useRef(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { getTranslation } = useTranslation('COMMON');

  const handleOpenPopover = (e) => {
    // make sure that the clicked target is not inside ref
    if (boxRef.current.contains(e.target)) {
      setIsPopoverOpen(!isPopoverOpen);
    }
  };

  // const handleClickDiscountBox = () => {
  //   // box action
  // };

  // const renderNotifContent = (
  //   <>
  //     <div className={styles.title_box}>
  //       <span>یه فرصت استثنائی😍</span>
  //     </div>

  //     <div style={{ display: 'flex' }}>
  //       <span className={styles.plain_text}>
  //         تا ۳۰٪ تخفیف تمدید سالانه در جشنواره نوروزی رایچت
  //       </span>
  //     </div>

  //     <div
  //       onClick={handleClickDiscountBox}
  //       className={styles.discount_code_box}
  //     >
  //       <img src={discount} alt='discount' />
  //       <span className={styles.discount_code}>کد تخفیف : Eydi1403</span>
  //     </div>
  //   </>
  // );

  // just render notif content in desktop view
  const renderNotifBoxContent = isMdDown ? (
    <div
      onClick={() => {
        setShowMenu(!showMenu);
      }}
      className={styles.menu_icon}
    >
      {/* <img src={menuIcon} alt='menu' /> */}
      <HamburgerIconComponent />
    </div>
  ) : (
    // render notif here
    // TODO: extract frequent notifs orderly to reuse them later

    <div className={styles.notif_box}>
      {/* <img src={InfoBoldIcon} alt='notice' /> */}
      <div className={styles.notif_text}>
        <span className={styles.title}> رایچت آپدیت شد!🥳</span> از طریق{' '}
        <a href='https://raychat.io/updates' target='_blank' rel='noreferrer'>
          لینک
        </a>{' '}
        می‌تونید آخرین بروزرسانی‌های ما رو دنبال کنید.
      </div>
      {/* {renderNotifContent} */}
      {/* <span style={{ fontWeight: 'bold' }}> فقط تا ۲۰ فروردین فرصت داری!</span>
      <span style={{ margin: '0px 8px' }}>
        {' '}
        تا اکانتت رو با همون قیمت پارسال، قبل از افزایش قیمت، تمدید کنی🥳 این
        فرصت تکرار نشدنی رو حیفه که از دست بدی.
      </span> */}
    </div>
  );

  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setIsPopoverOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <header className={clsx(styles.header, 'CustomContainer')}>
      <div className={styles.notif_container}>{renderNotifBoxContent}</div>

      <div className={styles.profile_container}>
        <LangMenu />
        <div className='primary__menu__bottom flex flex-jc-c flex-ai-c'>
          <div className='primary__menu__bottom__notificatoin flex flex-jc-c flex-ai-c'>
            <NotificationsPopover />
          </div>
        </div>
        <div
          ref={boxRef}
          onClick={handleOpenPopover}
          className={styles.profile_box}
        >
          <div
            data-open={isPopoverOpen}
            className='primary__menu__bottom__profile'
          >
            <div style={{ cursor: 'initial' }}>
              <ProfilePopover handlePopoverOpen={setIsPopoverOpen} />
            </div>
            {!isMdDown && (
              <span className={styles.profile_text}>
                {' '}
                {getTranslation().t('USER_PROFILE')}{' '}
              </span>
            )}
            <div data-open={isPopoverOpen} className={styles.arrow_cotainer}>
              <ChevronDownIcon />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
